<template>
  <div class="bg-white m-3 rounded-md pb-5">
    <ve-table
        :columns="columns"
        :table-data="employeeData"
    />
  </div>
</template>
<script>
  import axios from "axios";
  import {mapGetters} from "vuex";

  export default  {
    name:"myMonthlyReview",
    computed: {
      ...mapGetters(["getOrganization", "getToken"]),
    },
    created() {
      this.getPerformancePeriodSetups()
    },
    data(){
      return {
        employeeData:[],
        activePeriod: null,
        columns: [
          {
            field: "Month", key: "a", title: "Month", align: "left",
            renderBodyCell: ({ row }) => (
                <p class="capitalize">{row.EmployeeNo}</p>
            ),
          },
          {
            field: "Year",
            key: "b",
            title: "Year",
            align: "left",
            renderBodyCell: ({ row }) => (
                <p class="capitalize">{row.EmployeeName}</p>
            ),
          },
          {
            field: "Date Created",
            key: "b",
            title: "Date Created",
            align: "left",
            renderBodyCell: ({ row }) => (
                <p class="capitalize">{row.EmployeeName}</p>
            ),
          },

          {
            title: "Action",
            field: "",
            key: "action",
            renderBodyCell: ({ row }) => (
                <span class="underline text-blue-800 cursor-pointer" onClick={() => this.fetchEmployeeObjectives(row)}>View</span>

            ),
          },
        ],
      }
    },

    methods:{
      getPerformancePeriodSetups() {
        this.loading = true;
        let url = `${this.getOrganization}/performance/period/${this.$ApiVersion}/request`;

        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
          },
        };
        axios.get(url, options).then(
            (response) => {
              this.loading = false;
              if (response.data.StatusCode == 200) {
                this.activePeriod=response.data.Data.find(
                    (period) => period.Active == true
                );
                this.fetchMonthlyReviews();
              } else {
                this.$notify.error({
                  title: 'Failure',
                  message: response.StatusMessage,
                });
              }
            },
            (error) => {
              this.loading = false;
              this.$notify.error({ title: 'Failure', message: error.message });
            }
        );
      },
      fetchMonthlyReviews() {
        this.loading = true;
        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
          },
          params:{
            periodId:this.activePeriod.Id
          }
        };
        const apiUrl = `${this.getOrganization}/employee/performance/review/monthly/${this.$ApiVersion}/request`;

        axios
            .get(apiUrl, options)
            .then((response) => {
              this.loading = false;
              if (response.data.StatusCode == 200) {
                this.tableData = response.data.Data;
              } else {
                this.$notify.error({
                  title: "Failure",
                  message: "Error occured while fetching data.",
                });
              }
            })
            .catch((error) => {
              this.loading = false;
              this.$notify.error({
                title: "Failure",
                message: "Error occured while fetching records.",
              });
              console.error("Error fetching data:", error);
            });
      },
    }
  }
</script>